/* eslint-disable complexity */
import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  signal,
  WritableSignal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InboundConnectionsService } from '@flight-details/pax-connections/inbound-connections/inbound-connections.service';
import {
  InboundConnection,
  InboundConnectionsView,
} from '@flight-details/pax-connections/inbound-connections/models/inbound-connections.view';
import { LegView } from '@sequence/models/view/leg.view';
import { RequestState } from '@shared/models/request-state';
import { SharedModule } from '@shared/modules/shared.module';
import { DurationPipe } from '@shared/pipes/duration.pipe';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-inbound-connections',
  templateUrl: './inbound-connections.component.html',
  styleUrl: './inbound-connections.component.scss',
  standalone: true,
  imports: [FormsModule, SharedModule, AsyncPipe, DurationPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InboundConnectionsComponent implements OnChanges {
  @Input() flightState?: LegView;

  paxConnections$?: Observable<RequestState<InboundConnectionsView>>;

  filter: WritableSignal<'all' | 'caution' | 'warning'> = signal('all');

  constructor(private inboundConnectionsService: InboundConnectionsService) {}

  ngOnChanges(): void {
    this.loadData();
  }

  refresh() {
    this.loadData(true);
  }

  getLogo(airline: string): string {
    return `assets/${airline.toUpperCase()}.png`;
  }

  logoError(event: Event): void {
    const el = event.target as HTMLImageElement;
    el.src = 'assets/not_found.png';
  }

  getDeltaClass(pax: InboundConnection): string {
    if (!pax.delta) {
      return '';
    }

    const minutes = pax.delta.as('minutes');

    if (minutes >= 45) {
      return 'success-color';
    }

    if (minutes < 45 && minutes >= 20) {
      return 'caution-color';
    }

    if (minutes < 20) {
      return 'warn-color';
    }

    return '';
  }

  private loadData(isRefresh = false): void {
    if (this.flightState) {
      this.paxConnections$ =
        this.inboundConnectionsService.getInboundConnections(
          this.flightState,
          isRefresh,
        );
    }
  }
}
